exports.cs = {
  UNIFORM_DETAIL: {
    INVALID_INPUT: 'Pole není vyplněno správně.',
    INVALID_TEL: 'Zadali jste špatný formát telefonního čísla.',
    INVALID_TEL_1_800: 'Zadali jste špatný formát telefonního čísla.',
    ERROR_REQUIRED: 'Zadejte prosím požadované údaje.',
    ERROR_PATTERN: 'Údaje nejsou ve správném formátu.',
    ERROR_MINLENGTH: 'Zkuste zadat více znaků.',
    ERROR_MAXLENGTH: 'Zkuste zadat méně znaků.',
    INVALID_BIRTHNUMBER_MODULO: 'Zadali jste rodné číslo ve špatném formátu.'
  }
}
